import Location from './location'

const params= 
[
	{
		target: document.getElementById('location-rest-stop-01'),
		center: { lat: 37.550413, lng: 127.184724 }
	}
]
const location= new Location( params );
location.run();